<template>
  <div class="sakums-page">
    <LandingNavbar />
    <div class="top-section d-flex flex-row justify-center py-sm-16">
      <div class="page-content d-flex flex-column flex-sm-row py-16">
        <div class="d-flex flex-column justify-start justify-sm-center align-center align-sm-start v-col-sm-6 text-center text-sm-start">
          <h1>
            Soma pirmsskolām
          </h1>
          <p class="pt-4 pr-2">
            Platformā Soma pieejamie resursi pirmsskolām būs labs ideju un metožu krājums pedagogiem, kā arī iespēja vecākiem kopā ar saviem bērniem apgūt dažādas prasmes un izzināt pasauli!
          </p>
        </div>
        <div
          class="d-flex v-col-sm-6"
        >
          <v-img
            cover
            alt="Soma pirmsskolām"
            src="/v2/images/Soma_Pirmsskola.png"
          >
          </v-img>
        </div>
      </div>
    </div>
    <div class="second-section w-100 d-flex flex-column justify-start align-center py-16">
      <div class="page-content d-flex flex-column flex-sm-row justify-center align-start text-center text-sm-start">
        <div class="d-flex flex-column justify-center align-center align-sm-start px-4 v-col-sm-6">
          <h2 class="mb-4">
            Saturs pirmsskolām
          </h2>
          <h6>
            E-grāmatas
          </h6>
          <p>
            Šeit atradīsiet ilustrētas grāmatas, lai apgūtu burtus un skaņas, lasītprasmi, ciparus, skaitļus, loģiku un vienkāršas matemātiskas darbības. Grāmatas ir pilnas ar praktiskiem uzdevumiem un krāsainām ilustrācijām.
          </p>
          <h6>
            Video
          </h6>
          <p>
            Dabaszinību jautājumu dziļākai izpratnei pirmsskolā var izmantot jaunāko klašu skolēniem paredzētos video par dabu un pasauli, kas ir ierunāti vienkāršā un labi uztveramā latviešu valodā.
          </p>
          <h6>
            Darba lapas
          </h6>
          <p>
            Šeit pieejams plašs praktisko uzdevumu krājums, lai bērni iepazītu dabaszinību jautājumus, mācītos rakstīt burtus, lasīt, zīmēt, apgūt ciparus, izprast, kāds ir skaitļu sastāvs, kā izskatās ģeometriskās figūras. Darba lapas ir ērti izdrukājamas, taču ar tām var strādāt arī digitāli. Atrodama arī jaunākā "Sākam mācīties!" krāsaino rakstāmgrāmatu sērija, kas izdota pavisam nesen un veidota atbilstoši aktuālajām pirmsskolas vadlīnijām.
          </p>
        </div>
        <div
          class="d-flex v-col-sm-6"
          style="width: 100%; height: 100%;"
        >
          <v-img
            alt="Soma pirmsskolām ilustrācija"
            src="/v2/images/Soma_PirmsskolaIllustracija-01.png"
            class="bordered-image"
            color="rgba(0, 0, 0, 0)"
          >
          </v-img>
        </div>
      </div>
      <div class="page-content d-flex flex-column-reverse flex-sm-row justify-center align-start text-center text-sm-start v-col-sm-6">
        <div
          class="d-flex"
          style="width: 100%; height: 100%;"
        >
          <v-img
            alt="Soma pirmsskolām ilustrācija"
            src="/v2/images/Soma_PirmsskolaIllustracija-03.png"
            class="bordered-image"
            color="rgba(0, 0, 0, 0)"
          >
          </v-img>
        </div>
        <div class="d-flex flex-column justify-center align-sm-start align-center text-center text-sm-start v-col-sm-6">
          <h2 class="mb-4">
            Resursi skolotājiem
          </h2>
          <h6>
            Metodiskie līdzekļi
          </h6>
          <p>
            Lielvārds izstrādātie metodiskie materiāli ir pieejami digitāli un sasniedzami no jebkuras vietas un viedierīces. Metodiskie līdzekļi ir veidoti tematiski piecgadnieku un sešgadnieku mācību gadam. Tajos ir iekļauti komentāri par “Sākam mācīties!” sešu rakstāmgrāmatu uzdevumiem, kā arī dažādi papildmateriāli, tostarp eksperimentu un rokdarbu apraksti, rotaļas, uzdevumi utt.
          </p>
          <h6>
            Tehnoloģijas un eksperimenti pirmsskolā
          </h6>
          <p>
            Platformā Soma ir pieejami eksperimentu un robotikas uzdevumi, kas būs interesanti pirmsskolas vecuma bērniem un ērti lietojami skolotājiem. Ar eksperimentu palīdzību skolotājs var radīt bērnos interesi par tādiem procesiem kā gaisma, skaņa, ūdens un gaiss. Resursos atradīsiet arī noderīgu rokasgrāmatu, kā mācību darbam lietot Photon robotu.
          </p>
          <h6>
            Drukājamie un digitālie resursi
          </h6>
          <p>
            Pieejamais saturs ir piemērots bērnu vecumposmam. Mācību resursus iespējams gan rādīt uz ekrāna, gan ērtu un vienkārši izdrukāt papīra formātā.
          </p>
        </div>
      </div>
    </div>
    <div class="third-section w-100 d-flex flex-row justify-center align-center py-sm-12 text-center text-sm-start">
      <div class="page-content d-flex flex-column flex-sm-row justify-center align-center align-sm-start px-2">
        <div class="features-column d-flex flex-column pa-4 ma-2 v-col-sm-6">
          <h3 class="mb-4">
            Mācies Somā
          </h3>
          <p>
            Izmantojot pirmsskolas kolektīvo abonementu, Soma būs pieejama pedagogiem, vecākiem un bērniem. Viss, kas nepieciešams, ir interneta savienojums!
          </p>
        </div>
        <div class="features-column d-flex flex-column pa-4 ma-2 v-col-sm-6">
          <h3 class="mb-4">
            Integrācija ar E-klasi vai Eliis
          </h3>
          <p>
            Ja jūsu pirmsskola izmanto skolvadības sistēmu E-klase vai Eliis, tas piešķir papildu iespējas – ar kolektīvo abonementu piekļuve saturam tiek nodrošināta ar ērtu pieslēgšanos caur skolvadības pasēm gan visiem pedagogiem, gan vecākiem.
          </p>
        </div>
      </div>
    </div>

    <div class="fourth-section d-flex flex-column flex-sm-row justify-center align-center py-12 w-100">
      <div class="page-content d-flex justify-center align-center flex-column flex-sm-row">
        <div class="d-flex flex-column justify-center align-center align-sm-start px-4 text-sm-start text-center text-sm-start">
          <h3>
            Kolektīvais abonements visai pirmsskolai!
          </h3>
          <p class="pt-4 pr-2 text-center text-sm-start">
            Kolektīvā izdevīgāk! Ja vēlaties uzzināt pirmsskolas kolektīvā abonementa piedāvājumu, kas nodrošinās pieeju visiem iestādes pedagogiem, vecākiem un bērniem, lūdzu, rakstiet soma@lielvards.lv vai zvaniet +371 67801787!
          </p>
        </div>
        <div
          class="d-flex"
          style="width: 100%; height: 100%;"
        >
          <v-img
            cover
            alt="Soma pirmsskolām abonements"
            src="/v2/images/Soma_PirmsskolaAbonaments-1.png"
          >
          </v-img>
        </div>
      </div>
    </div>

    <div class="footer-section d-flex w-100 align-center justify-center py-8 px-4">
      <div class="d-flex flex-column flex-sm-row justify-space-between justify-sm-space-between align-start align-sm-start page-content w-100">
        <div class="d-flex">
          <v-img
            src="/v2/images/Soma_Lockup_2023.png"
            width="200"
            alt="Soma logo"
            height="75"
          >
          </v-img>
        </div>
        <div class="d-flex flex-column justify-center align-start">
          <p class="footer-topic">
            Kontakti:
          </p>
          <p>
            +371 67801787<br>
            soma@lielvards.lv
          </p>
        </div>
        <div class="d-flex flex-column justify-center align-start">
          <p class="footer-topic">
            Rekvizīti:
          </p>
          <p>
            Lielvārds SIA<br>
            47403001219<br>
            Skolas iela 5,<br>
            Lielvārde, Ogres novards, LV-5070
          </p>
        </div>
        <div class="d-flex flex-column justify-center align-start">
          <p class="footer-topic">
            Informācija:
          </p>
          <NuxtLink
            to="/lietosanas-noteikumi"
            target="_blank"
          >
            Lietošanas noteikumi
          </NuxtLink>
          <NuxtLink
            to="/privatuma-politika"
            target="_blank"
          >
            Privātuma politika
          </NuxtLink>
          <NuxtLink
            to="/sikdatnu-politika"
            target="_blank"
          >
            Sīkdatņu politika
          </NuxtLink>
          <NuxtLink
            to=""
            target="_blank"
          >
            Pieejamība
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import LandingNavbar from "~/components/home-page/landing/LandingNavbar.vue"

export default {
  components: { LandingNavbar },

  setup() {
    definePageMeta({
      layout: false,
    })
  },

  mounted() {
    window.hideBeacon()
  },

  beforeUnmount() {
    window.unhideBeacon()
  },
}
</script>
<style scoped lang="sass">
@use "~/assets/css/vuetify/settings" as *

$yellow: #F8D70C
$almond: #FDF1CD
$green: #21CD7F
$orange: #FA4C42
$grey: #EFEFEF
$marzipan: #FAE68F
$purple: #F5F4F8
$moss: #D8EDDD
$pink: #FBE9EC
$sky: #D1ECF5
$anotherYellow: #FFD531

.sakums-page
  position: relative
  letter-spacing: 0px !important
  font-size: 1rem
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
.top-section
  width: 100%
  background-color: $marzipan
  .page-content
    z-index: 1003

.second-section
  position: relative
  background-color: $purple
  h2
    font-size: 23px
  h6
    font-size: 18px

.third-section
  z-index: 1001
  .features-column
    min-height: 14rem
    height: 100%
    @media #{map-get($display-breakpoints, 'sm-and-up')}
      height: 16rem
    border-radius: 15px
    background-color: $moss
    &:nth-of-type(2)
      background-color: $pink

.fourth-section
  background-color: $sky
  p
    text-align: center

.footer-section
  a
    transition: color 0.2s ease, box-shadow 0.2s ease
    color: $orange
    text-decoration: none
    &:hover
      color: #262626

.footer-section
  background-color: $marzipan
  p,
  a
    line-height: 1.5rem
    font-size: 18px
    color: #262626
  .footer-topic
    font-weight: 800
    margin-bottom: 0.5rem

.page-content
  max-width: 1230px
h1
  font-size: 2rem
  font-weight: 800
  color: #262626
  letter-spacing: 0.05rem
  line-height: 2.875rem
h2
  font-size: 1.75rem
  letter-spacing: 0.05rem
  line-height: 2.125
  font-weight: 800
h3
  font-size: 1.75rem
  letter-spacing: 0.05rem
  line-height: 2.5rem
  font-weight: 800
h6
  font-size: 1.25rem
  letter-spacing: 0.05rem
  line-height: 2rem
  font-weight: 800
p
  font-size: 1.125rem
  color: #262626
  margin-bottom: 1.5rem
  font-weight: 400
  white-space: pre-line

.bordered-image
  border-radius: 200px
</style>
